import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Fieldset, NoPrintDiv } from "commons";
import { format } from "commons/src/NuDateUtils";

import { AccountDetails } from "./AccountDetails";
import { RegularTable } from "./RegularTable";
import { RegularTableRow } from "./RegularTableRow";

export class AccountSummary extends Component {
    render() {
        let contRows, withdrawalRows;
        if (this.props.accountDetails !== undefined) {
            contRows = this.props.accountDetails.accountDetails.regularContributions.map(
                (item, idx) => {
                    return (
                        <RegularTableRow
                            key={`contribution-${idx}`}
                            type={item.type}
                            amount={item.amount}
                            frequency={item.frequency}
                            next={format(item.nextContributionDate)}
                            bankDetails={item.bankDetails}
                            bankSortCode={item.bankSortCode}
                            bankAccountNumber={item.bankAccountNumber}
                        />
                    );
                }
            );

            withdrawalRows = this.props.accountDetails.accountDetails.regularWithdrawals.map(
                (item, idx) => {
                    return (
                        <RegularTableRow
                            key={`withdrawal-${idx}`}
                            type={item.type}
                            amount={item.amount}
                            frequency={item.frequency}
                            next={format(item.nextContributionDate)}
                            bankDetails={item.bankDetails}
                            bankSortCode={item.bankSortCode}
                            bankAccountNumber={item.bankAccountNumber}
                        />
                    );
                }
            );
        }

        return (
            <NoPrintDiv>
                <Fieldset>
                    <legend>Account summary</legend>
                    <AccountDetails
                        clientDetails={this.props.clientDetails}
                        accountDetails={this.props.accountDetails}
                    />
                    <RegularTables>
                        <RegularTable
                            title="Regular payments"
                            nextHeader="Next payment date"
                            rows={contRows}
                        />
                        <RegularTable
                            title="Regular withdrawals"
                            nextHeader="Next withdrawal date"
                            rows={withdrawalRows}
                        />
                    </RegularTables>
                </Fieldset>
            </NoPrintDiv>
        );
    }
}

const RegularTables = styled.div`
    float: right;
    width: 50%;
`;

AccountSummary.propTypes = {
    clientDetails: PropTypes.object,
    accountDetails: PropTypes.shape({
        accountDetails: PropTypes.shape({
            regularContributions: PropTypes.array,
            regularWithdrawals: PropTypes.array
        })
    })
};

AccountSummary.defaultProps = {
    clientDetails: {},
    accountDetails: {
        accountDetails: {
            regularContributions: [],
            regularWithdrawals: []
        }
    }
};
